import $ from 'jquery';
import { getState } from '~src/state';

export const onSidebarSubTabChange = (activeTab) => {
  if (
    activeTab === 'backgrounds-custom' ||
    activeTab === 'backgrounds-default'
  ) {
    const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');

    const editorBackgroundsDefaultHasNextPage = getState(
      `${currentTag}.editorBackgroundsDefaultHasNextPage`
    );
    const editorBackgroundsHasNextPage = getState(
      `${currentTag}.editorBackgroundsHasNextPage`
    );
    if (
      activeTab === 'backgrounds-default' &&
      editorBackgroundsDefaultHasNextPage
    ) {
      $('#fetchMoreBackgrounds').show();
    } else if (
      activeTab === 'backgrounds-custom' &&
      editorBackgroundsHasNextPage
    ) {
      $('#fetchMoreBackgrounds').show();
    } else {
      $('#fetchMoreBackgrounds').hide();
    }
  }
};
